import type { JSX } from "react";

/**
 * Auslastung. Die Zahl steht immer daneben, nie nur der Balken (StyleGuide 5) — ein
 * Balken allein sagt dem Veranstalter nicht, ob noch vier oder vierzig Plätze frei sind.
 */
export function Meter({
  used,
  capacity,
  thin = false,
}: {
  used: number;
  capacity: number;
  thin?: boolean;
}): JSX.Element {
  const share = capacity > 0 ? Math.min(100, Math.round((used / capacity) * 100)) : 0;
  return (
    <div className="flex items-center gap-2.5">
      <div
        className={thin ? "meter thin" : "meter"}
        role="progressbar"
        aria-valuenow={used}
        aria-valuemin={0}
        aria-valuemax={capacity}
        aria-label="Auslastung"
      >
        <span style={{ width: `${share}%` }} />
      </div>
      <span className="num text-[12.5px] font-bold text-ink-2">
        {used}/{capacity}
      </span>
    </div>
  );
}
